// ** Checks if an object is empty (returns boolean)
export const isObjEmpty = obj => Object.keys(obj).length === 0

// ** Returns K format from a number
export const kFormatter = num => (num > 999 ? `${(num / 1000).toFixed(1)}k` : num)

// ** Converts HTML to string
export const htmlToString = html => html.replace(/<\/?[^>]+(>|$)/g, '')

// ** Checks if the passed date is today
const isToday = date => {
    const today = new Date()
    return (
        /* eslint-disable operator-linebreak */
        date.getDate() === today.getDate() &&
        date.getMonth() === today.getMonth() &&
        date.getFullYear() === today.getFullYear()
        /* eslint-enable */
    )
}

/**
 ** Format and return date in Humanize format
 ** Intl docs: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/format
 ** Intl Constructor: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
 * @param {String} value date to format
 * @param {Object} formatting Intl object to format with
 */
export const formatDate = (value, formatting = {month: 'short', day: 'numeric', year: 'numeric'}) => {
    if (!value) return value
    return new Intl.DateTimeFormat('en-US', formatting).format(new Date(value))
}

// ** Returns short month of passed date
export const formatDateToMonthShort = (value, toTimeForCurrentDay = true) => {
    const date = new Date(value)
    let formatting = {month: 'short', day: 'numeric'}

    if (toTimeForCurrentDay && isToday(date)) {
        formatting = {hour: 'numeric', minute: 'numeric'}
    }

    return new Intl.DateTimeFormat('en-US', formatting).format(new Date(value))
}

/**
 ** Return if user is logged in
 ** This is completely up to you and how you want to store the token in your frontend application
 *  ? e.g. If you are using cookies to store the application please update this function
 */
export const isUserLoggedIn = () => localStorage.getItem('userData')
export const getUserData = () => JSON.parse(localStorage.getItem('userData'))

/**
 ** This function is used for demo purpose route navigation
 ** In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 ** Please note role field is just for showing purpose it's not used by anything in frontend
 ** We are checking role just for ease
 * ? NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} userRole Role of user
 */
export const getHomeRouteForLoggedInUser = userRole => {
    if (userRole === 'admin') return '/'
    if (userRole === 'client') return '/access-control'
    return '/login'
}

// ** React Select Theme Colors
export const selectThemeColors = theme => ({
    ...theme,
    colors: {
        ...theme.colors,
        primary25: '#7367f01a', // for option hover bg-color
        primary: '#7367f0', // for selected option bg-color
        neutral10: '#7367f0', // for tags bg-color
        neutral20: '#ededed', // for input border-color
        neutral30: '#ededed' // for input hover border-color
    }
})
// ** React Imports
/**
 * Return which component to render based on it's data/context
 * @param {Object} item nav menu item
 */
export const resolveVerticalNavMenuItemComponent = item => {
    if (item.header) return 'VerticalNavMenuSectionHeader'
    if (item.children) return 'VerticalNavMenuGroup'
    return 'VerticalNavMenuLink'
}

/**
 * Return which component to render based on it's data/context
 * @param {Object} item nav menu item
 */
export const resolveHorizontalNavMenuItemComponent = item => {
    if (item.children) return 'HorizontalNavMenuGroup'
    return 'HorizontalNavMenuLink'
}

/**
 * Check if nav-link is active
 * @param {Object} link nav-link object
 */
// export const isNavLinkActive = (link, currentURL, match) => {
//   // return currentURL === link || (URLParams && Object.keys(URLParams).length && currentURLFilter === item.navLink)
//   const getFirstObjProp = obj => obj[Object.keys(obj)[0]]
//   return (
//     currentURL === link ||
//     (match !== null && match !== undefined && match.url === `${link}/${getFirstObjProp(match.params)}`)
//   )
// }

export const isNavLinkActive = (link, currentURL, routerProps) => {
    return (
        currentURL === link ||
        (routerProps && routerProps.meta && routerProps.meta.navLink && routerProps.meta.navLink === link)
    )
    // return currentURL === link
}

/**
 * Check if nav group is
 * @param {Array} children Group children
 */
// export const isNavGroupActive = (children, currentURL, match) => {
//   return children.some(child => {
//     // If child have children => It's group => Go deeper(recursive)
//     if (child.children) {
//       return isNavGroupActive(child.children, currentURL, match)
//     }
//     // else it's link => Check for matched Route
//     return isNavLinkActive(child.navLink, currentURL, match)
//   })
// }

/**
 * Recursively checks whether any child in a navigation group is active based on
 * the current URL and/or router props. Returns `true` if at least one child is active,
 * `false` otherwise.
 *
 * @param {Object[]} children - An array of child objects representing a navigation group.
 * @param {string} currentURL - The current URL being navigated to.
 * @param {Object} routerProps - Additional properties passed by the router (e.g. `match`, `location`, `history`).
 * @returns {boolean} `true` if at least one child is active, `false` otherwise.
 */
export const isNavGroupActive = (children, currentURL, routerProps) =>
    children.some((child) => {
        if (child.children) {
            return isNavGroupActive(child.children, currentURL, routerProps);
        }
        return isNavLinkActive(child.navLink, currentURL, routerProps);
    });


/**
 * Search for parent object
 * @param {Array} navigation Group children
 * @param {string} currentURL current URL
 */
// export const search = (navigation, currentURL, match) => {
//   let result
//   navigation.some(child => {
//     let children
//     // If child have children => It's group => Go deeper(recursive)
//     if (child.children && (children = search(child.children, currentURL, match))) {
//       return (result = {
//         id: child.id,
//         children
//       })
//     }

//     // else it's link => Check for matched Route
//     if (isNavLinkActive(child.navLink, currentURL, match)) {
//       return (result = {
//         id: child.id
//       })
//     }
//   })
//   return result
// }


/**
 * Recursively searches through a navigation object to find a child that matches
 * the current URL and/or router props. Returns an object representing the matched
 * child, including its ID and any nested children.
 *
 * @param {Object[]} navigation - The navigation object to search.
 * @param {string} currentURL - The current URL being navigated to.
 * @param {Object} routerProps - Additional properties passed by the router (e.g. `match`, `location`, `history`).
 * @returns {?Object} An object representing the matched child, or `null` if no match was found.
 */
export const search = (navigation, currentURL, routerProps) => {
    for (const child of navigation) {
        if (child.children) {
            const childrenResult = search(child.children, currentURL, routerProps);
            if (childrenResult) {
                return {
                    id: child.id,
                    children: childrenResult
                };
            }
        } else if (isNavLinkActive(child.navLink, currentURL, routerProps)) {
            return {
                id: child.id
            };
        }
    }
    return null;
};


/**
 * Returns an array of all values in the given object that correspond to
 * a key matching the specified string. Searches recursively through the
 * object's nested properties.
 *
 * @param {Object} obj - The object to search through.
 * @param {string} match - The string to match against keys in the object.
 * @returns {any[]} An array of values corresponding to matching keys.
 */
export const getAllParents = (obj, match) => {
    const res = [];

    /**
     * Recursively searches through the given object and its nested properties
     * for keys that match the specified string. If a matching key is found and
     * its value is not an object, pushes the value to the result array.
     *
     * @param {Object} obj - The object to search through.
     * @param {string} current - The name of the current property being searched.
     */
    const recurse = (obj, current) => {
        if (!obj) {
            return;
        }

        Object.entries(obj).forEach(([key, value]) => {
            if (value && typeof value === 'object') {
                recurse(value, key);
            } else if (key === match) {
                res.push(value);
            }
        });
    };

    recurse(obj);

    return res;
};


/**
 * Checks if the current user has all of the specified permissions.
 *
 * @param {string[]} permissions - An array of permission names to check.
 * @param {object} auth - The authentication object containing the user's permissions.
 * @param {string[]} [auth.permissions=[]] - An array of the user's permission names. Defaults to an empty array if not provided.
 * @returns {boolean} True if the user has all of the specified permissions, false otherwise.
 */
const CheckPermissions = (permissions, auth) => {
    const currentUserPermissions = new Set(auth.permissions || []);

    if (permissions.length === 0) {
        return true; // No restrictions on permissions
    }

    return permissions.some(permission => currentUserPermissions.has(permission));
}


/**
 * Checks if the current user has any of the specified roles.
 *
 * @param {string[]} roles - An array of role names to check.
 * @param {object} auth - The authentication object containing the user's roles.
 * @param {string[]} [auth.roles=[]] - An array of the user's role names. Defaults to an empty array if not provided.
 * @returns {boolean} True if the user has at least one of the specified roles, false otherwise.
 */
const CheckRole = (roles, auth) => {
    const current_user_roles = auth.roles || [];
    return roles?.some(role => current_user_roles.includes(role)) || roles?.length === 0;
}


export const canViewMenuGroup = (item, auth) => {
    return (CheckRole(item.roles, auth) && CheckPermissions(item.permissions, auth)) || item.roles === undefined;
}

export const canViewMenuItem = (item, auth) => {
    return (CheckRole(item.roles, auth) && CheckPermissions(item.permissions, auth)) || item.roles === undefined;
}
